import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { ACTIVITY_LABELS, ACTIVITY_ICONS, shortDate, contactName } from './constants';
import './Screens.css';

// Everything logged, newest first, across every account.

const Activity = () => {
  const navigate = useNavigate();
  const [activities, setActivities] = useState([]);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchActivities = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/crm/activities?limit=200');
      setActivities(response.data.activities);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load activity');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchActivities(); }, [fetchActivities]);

  const shown = type ? activities.filter(a => a.activity_type === type) : activities;

  return (
    <div className="crm-screen">
      <div className="screen-header">
        <div>
          <h1>Activity</h1>
          <p className="subtitle">Every call, text, visit, and note logged across the CRM</p>
        </div>
      </div>

      <div className="filters">
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="">All activity</option>
          {Object.entries(ACTIVITY_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>

      {error && <p className="banner error">{error}</p>}
      {loading && <p className="loading">Loading…</p>}

      {!loading && shown.length === 0 ? (
        <div className="card">
          <p className="empty">
            <strong>Nothing logged yet</strong>
            A CRM with no activity in it is just a contact list. Log from an account screen —
            it takes a few taps.
          </p>
        </div>
      ) : (
        <ul className="crm-list">
          {shown.map(a => (
            <li key={a.id}>
              <div className="li-main">
                <div className="li-title">
                  <span style={{ marginRight: 8 }}>{ACTIVITY_ICONS[a.activity_type] || '📝'}</span>
                  {a.summary}
                </div>
                <div className="li-sub">
                  {[ACTIVITY_LABELS[a.activity_type], shortDate(a.occurred_at),
                    contactName(a), a.sport, a.user_first_name].filter(Boolean).join(' · ')}
                </div>
                {a.body && <div className="li-sub" style={{ marginTop: 6, whiteSpace: 'pre-wrap' }}>{a.body}</div>}
              </div>
              <div className="li-actions">
                <button type="button" className="tap" onClick={() => navigate(`/crm/organizations/${a.organization_id}`)}>
                  Open account
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Activity;
